import { AxiosAPI } from "./axios-service-creator";

export const UserAPI = {
  checkUserExist: (username: string) => AxiosAPI.post("/users", { username }),
  changePassword: (username: string, password: string) =>
    AxiosAPI.post("/users/reset/password", { username, password }),
};
